import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b87fd90c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b87fd90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87fd90c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b87fd90c')) {
      api.createRecord('b87fd90c', component.options)
    } else {
      api.reload('b87fd90c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b87fd90c&scoped=true&", function () {
      api.rerender('b87fd90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4KDbAWZsR9hBC/JS/comp/GuestBox.vue"
export default component.exports